/**
 * Viñedo — reveal columns (pantalla congelada, columnas al scroll).
 * Adaptado de vinedos_webpage/script.js para scroll de ventana (Shopify).
 */
(function () {
  /**
   * @param {HTMLElement} section
   */
  function initVinedoRevealColumns(section) {
    if (section.dataset.vinedoRevealColumnsInit === 'true') return;
    section.dataset.vinedoRevealColumnsInit = 'true';

    const inners = section.querySelectorAll('.vinedo-reveal-columns__col-inner');
    const copyBlock = section.querySelector('.vinedo-reveal-columns__copy');
    const anchorId = section.id;

    function vhPx() {
      return window.innerHeight;
    }

    function getRevealedScrollTop() {
      return section.offsetTop + vhPx() * 0.7;
    }

    function updateReveal() {
      const scrollInSection = window.scrollY - section.offsetTop;
      const vh = vhPx();
      const phase1End = vh * 0.1;
      const phase2End = vh * 0.7;

      let progress;
      if (scrollInSection <= 0) {
        progress = 0;
      } else if (scrollInSection <= phase1End) {
        progress = (scrollInSection / phase1End) * 0.3;
      } else if (scrollInSection <= phase2End) {
        progress = 0.3 + ((scrollInSection - phase1End) / (phase2End - phase1End)) * 0.7;
      } else {
        progress = 1;
      }
      progress = Math.max(0, Math.min(1, progress));

      inners.forEach((el) => {
        const isCol3 = el.closest('.vinedo-reveal-columns__col--3');
        const p = isCol3 ? (progress <= 0.5 ? 0 : (progress - 0.5) / 0.5) : progress;
        const dir = el.dataset.revealDir;
        const offset = (1 - p) * 100;
        const translate = dir === 'up' ? offset : -offset;
        el.style.transform = `translateY(${translate}%)`;
      });

      if (copyBlock) {
        const copyOpacity = progress >= 0.75 ? Math.min(1, (progress - 0.75) / 0.25) : 0;
        copyBlock.style.opacity = String(copyOpacity);
      }
    }

    function scrollToRevealed(behavior) {
      window.scrollTo({ top: getRevealedScrollTop(), behavior: behavior || 'smooth' });
    }

    function onScroll() {
      updateReveal();
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      inners.forEach((el) => {
        el.style.transform = 'translateY(0)';
      });
      if (copyBlock) copyBlock.style.opacity = '1';
      return;
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    updateReveal();

    if (anchorId) {
      document.querySelectorAll(`a[href="#${anchorId}"]`).forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          scrollToRevealed('smooth');
          history.pushState(null, '', `#${anchorId}`);
        });
      });

      function applyHashScroll() {
        if (window.location.hash !== `#${anchorId}`) return;
        scrollToRevealed('auto');
      }

      applyHashScroll();
      requestAnimationFrame(applyHashScroll);
      window.addEventListener('hashchange', applyHashScroll);
    }
  }

  function initAll() {
    document.querySelectorAll('.vinedo-reveal-columns').forEach(initVinedoRevealColumns);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.matches?.('.vinedo-reveal-columns')
      ? event.target
      : event.target.querySelector?.('.vinedo-reveal-columns');

    if (section) {
      delete section.dataset.vinedoRevealColumnsInit;
      initVinedoRevealColumns(section);
    }
  });
})();
